import React, {Component} from 'react';
import qs from 'query-string';

class PlayerPage extends Component {
  componentDidMount() {
    console.log(location);
    let queryString = location.search;
    queryString = queryString.replace("movie_id", "video_id");
    const params = qs.parse(queryString);
    const videoId = params["video_id"];
    if(!videoId) {
      location.replace('/404.html');
    }
    let episodeId;
    const videos = this.props.data.allVideo.edges.map(edge => {
      return edge.node;
    });
    videos.forEach(video => {
      if(video.videoId === Number.parseInt(videoId)) {
        episodeId = video.episodeId;
      }
    });
    if(episodeId) {
      location.replace(`/episode/${episodeId}${queryString}`);
    } else {
      location.replace('/404.html');
    }
  }
  render() {
    return <div></div>
  }
}

export const query = graphql`
query playerPageQuery {
  allVideo {
    edges {
      node {
        id
        videoId
        episodeId
        
      }
    }
  }
}
`;

export default PlayerPage;



// WEBPACK FOOTER //
// ./src/pages/player.js